"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isICheckEquality = void 0;
function isICheckEquality(value) {
    if (typeof value.check !== "function") {
        return false;
    }
    return true;
}
exports.isICheckEquality = isICheckEquality;
//# sourceMappingURL=ICheckEquality.js.map